// reactjs-social-login's LoginSocialGoogle (in its default "accessToken"
// response mode, which this app uses) fetches the signed-in user's profile
// through a third-party CORS proxy the library author set up
// (cors.bridged.cc), rather than calling Google directly:
//   fetch("https://cors.bridged.cc/https://www.googleapis.com/oauth2/v3/userinfo?alt=json", ...)
// That proxy is unreliable (fails outright as of this writing) and routes
// the user's Google access token through an unrelated third party for no
// reason - Google's userinfo endpoint supports CORS directly (verified: it
// returns Access-Control-Allow-Origin for cross-origin GET requests), so
// the proxy hop isn't needed at all.
//
// fetch() is the only seam the library exposes for this call, so this
// patches it - scoped narrowly to that exact proxied URL - to call Google
// directly instead.
const PROXIED_PREFIX = "https://cors.bridged.cc/https://www.googleapis.com/";
const DIRECT_PREFIX = "https://www.googleapis.com/";

let patched = false;

export function fixGoogleUserinfoProxy() {
  if (patched) return;
  patched = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    if (typeof input === "string" && input.startsWith(PROXIED_PREFIX)) {
      input = DIRECT_PREFIX + input.slice(PROXIED_PREFIX.length);
      if (init && init.headers) {
        // Drop the proxy's own auth header before it goes to Google - a
        // custom header Google doesn't recognize makes its edge reject
        // the CORS preflight outright (403, no CORS headers at all)
        // rather than just declining to allow it.
        const headers = new Headers(init.headers);
        headers.delete("x-cors-grida-api-key");
        init = { ...init, headers };
      }
    }
    return originalFetch(input, init);
  };
}
